<template>
 <div>
 <el-col :span="span">
    <el-form-item 
    :label="label" 
    :label-width="labelWidth"
    :prop="prop"
    :required="required"
    >
      <slot> <span :title="content">{{content||"--"}}</span></slot>
    </el-form-item>
</el-col>
 </div>
</template>
<script>
export default {

  props: {
    label:{
        type:String,
        default:""
    },
    required:{
      type:Boolean,
      default:false,
    },
    span:{
      type:[Number,String],
      default:6
    },
    content:{
      type:[String,Number,Boolean],
      default:'',
    },
    "labelWidth":{
      type:String,
      default:""
    },
    prop:{
      default:"",
      type:String
    }
  },
  mounted() {
         
  },
  methods: {
  }
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/childcomponents/EleFormItem/index.vue